import React from "react";
import Lottie from "lottie-react";
import SpaceBoy from "../LottieFiles/SpaceBoy.json";
import Typed from "./Typed.js";
import Tilt from "react-parallax-tilt";
import Avatar from "../images/Avatar.png";
import { CiCoffeeCup } from "react-icons/ci";

const Home = () => {
  return (
    <div>
      <div className="HomePage">
        <div className="HomeText">
          <h1>Hey There!</h1>
          <h1>
            I'M <b>VISHNU</b>
          </h1>
          <Typed />
        </div>

        <Lottie className="illustration" animationData={SpaceBoy} loop={true} />
      </div>

      <div className="AboutPage">
        <div className="AboutText">
          <h1 className="AboutTextHeading">
            Brief <b>introduction</b>
          </h1>
          <p>
            I’m a compsci student with experience and knowledge in building full-stack and data-driven
            applications.
            <br />
            <br />
            I’ve worked on projects ranging from forecasting tools and analytics
            platforms to AI-powered applications, taking ideas from early
            prototypes to working systems.
            <br />
            <br />
            I’m currently an incoming Platform and AI Engineering Intern at{" "}
            <b>NexKey Collective</b>, and I’ve previously contributed to a
            demand forecasting project at <b>Royal Enfield</b> company.
            <br />
            <br />
            Outside of coding, I play <b>Basketball</b> and run on <b>coffee</b>{" "}
            <CiCoffeeCup style={{ scale: "1.5", rotate: "15deg" }} />
          </p>
        </div>
        <Tilt>
          <img className="Avatar" src={Avatar} alt="" />
        </Tilt>
      </div>
    </div>
  );
};

export default Home;
